import { CLEAR_ALL_PRESERVED_KEYS } from "../utils/activeFilters";
import { SORT_PARAM } from "../constants";
export const initialState = {
    filterConfig: [],
    pathFilters: [],
    facetData: {},
    loadingFacets: false,
    isInitialLoading: false,
    selectedState: {},
    committedState: {},
    offersCount: 0,
    initialized: false,
    initializationFailed: false,
    pendingRefresh: false,
    overlayOpen: false,
    overlayOpenedVia: "filters",
    focusedFilterId: null,
    lockedFinanceType: null,
    hiddenFilters: {},
};
export function offerFiltersReducer(state, action) {
    var _a, _b, _c, _d, _e;
    switch (action.type) {
        case "initialize_request":
            if (state.initialized || state.isInitialLoading)
                return state;
            return Object.assign(Object.assign({}, state), { isInitialLoading: true, initializationFailed: false });
        case "initialize_success":
            return Object.assign(Object.assign({}, state), { isInitialLoading: false, initialized: true, filterConfig: action.payload.filterConfig, pathFilters: action.payload.pathFilters, selectedState: action.payload.selectedState, committedState: action.payload.selectedState, facetData: action.payload.facetData, offersCount: (_a = action.payload.offersCount) !== null && _a !== void 0 ? _a : state.offersCount, pendingRefresh: false });
        case "initialize_failure":
            return Object.assign(Object.assign({}, state), { isInitialLoading: false, initializationFailed: true });
        case "facets_request":
            return Object.assign(Object.assign({}, state), { loadingFacets: true, pendingRefresh: false });
        case "facets_success":
            return Object.assign(Object.assign({}, state), { loadingFacets: false, facetData: action.payload.facets, offersCount: (_b = action.payload.offersCount) !== null && _b !== void 0 ? _b : state.offersCount });
        case "facets_failure":
            return Object.assign(Object.assign({}, state), { loadingFacets: false });
        case "set_selected":
            return Object.assign(Object.assign({}, state), { selectedState: action.payload, pendingRefresh: true });
        // Sort doesn't affect available facet options or counts, so update
        // selectedState without triggering a facets refresh.
        case "set_sort":
            return Object.assign(Object.assign({}, state), { selectedState: Object.assign(Object.assign({}, state.selectedState), { [SORT_PARAM]: action.payload }) });
        case "clear_all": {
            const preserved = {};
            for (const key of CLEAR_ALL_PRESERVED_KEYS) {
                if (state.selectedState[key] !== undefined) {
                    preserved[key] = state.selectedState[key];
                }
            }
            return Object.assign(Object.assign({}, state), { selectedState: preserved, pendingRefresh: true });
        }
        case "open_overlay":
            return Object.assign(Object.assign({}, state), { overlayOpen: true, overlayOpenedVia: "filters", focusedFilterId: null });
        case "open_overlay_sort":
            return Object.assign(Object.assign({}, state), { overlayOpen: true, overlayOpenedVia: "sort", focusedFilterId: null });
        case "open_overlay_focused":
            return Object.assign(Object.assign({}, state), { overlayOpen: true, overlayOpenedVia: "filters", focusedFilterId: action.payload.filterId });
        case "close_overlay":
            return Object.assign(Object.assign({}, state), { overlayOpen: false, focusedFilterId: null });
        case "commit_selected": {
            const committed = (_c = action.payload) !== null && _c !== void 0 ? _c : state.selectedState;
            return Object.assign(Object.assign({}, state), { selectedState: (_d = action.payload) !== null && _d !== void 0 ? _d : state.selectedState, committedState: committed });
        }
        case "apply_path_from_url":
            return Object.assign(Object.assign({}, state), { selectedState: Object.assign(Object.assign({}, state.selectedState), action.payload), committedState: Object.assign(Object.assign({}, state.committedState), action.payload) });
        case "sync_from_url_success":
            return Object.assign(Object.assign({}, state), { selectedState: action.payload.selectedState, committedState: action.payload.selectedState, facetData: action.payload.facetData, offersCount: (_e = action.payload.offersCount) !== null && _e !== void 0 ? _e : state.offersCount, loadingFacets: false, pendingRefresh: false });
        default:
            return state;
    }
}
